import { yup } from '@guiker/shared-framework'

import { Capabilities } from '../../../../entity'

export const payoutMethodCapabilitySchema = yup.object({
  capabilities: yup.array(yup.string().oneOf(Object.values(Capabilities))).nullable(),
})
